import type { Professional, Testimonial, Specialty, FilterOption, PaymentMethod } from '@/types';

export const specialties: Specialty[] = [
  { id: '1', name: 'Ansiedade', icon: 'Brain', description: 'Ajuda para lidar com ansiedade e preocupações excessivas' },
  { id: '2', name: 'Depressão', icon: 'CloudRain', description: 'Apoio para superar momentos difíceis e tristeza persistente' },
  { id: '3', name: 'Relacionamentos', icon: 'Heart', description: 'Orientação para melhorar relacionamentos pessoais' },
  { id: '4', name: 'Stress', icon: 'Zap', description: 'Técnicas para gerenciar stress do dia a dia' },
  { id: '5', name: 'Família', icon: 'Users', description: 'Apoio para questões familiares e dinâmicas' },
  { id: '6', name: 'Trauma', icon: 'Shield', description: 'Ajuda para processar experiências traumáticas' },
];

export const filterOptions: FilterOption[] = [
  { id: 'all', label: 'Todos' },
  { id: 'anxiety', label: 'Ansiedade' },
  { id: 'depression', label: 'Depressão' },
  { id: 'relationships', label: 'Relacionamentos' },
  { id: 'stress', label: 'Stress' },
  { id: 'family', label: 'Família' },
  { id: 'trauma', label: 'Trauma' },
];

export const professionals: Professional[] = [
  {
    id: '1',
    name: 'Dra. Ana Silva',
    photo: '/images/professional-1.jpg',
    specialty: 'Psicologia Clínica',
    specialties: ['Ansiedade', 'Depressão', 'Stress'],
    bio: 'Olá! Sou a Ana e ajudo pessoas a encontrarem mais calma e equilíbrio no dia a dia. Acredito que todos merecem ser ouvidos e apoiados.',
    education: 'Licenciatura em Psicologia - Universidade Agostinho Neto',
    languages: ['Português'],
    pricePerSession: 15000,
    currency: 'Kz',
    rating: 4.9,
    reviewCount: 127,
    isVerified: true,
    isAvailableToday: true,
    availability: [],
    whatsappNumber: '+244900000001',
    yearsOfExperience: 8,
    location: 'Luanda',
  },
  {
    id: '2',
    name: 'Dr. Carlos Mendes',
    photo: '/images/professional-2.jpg',
    specialty: 'Terapia de Casal',
    specialties: ['Relacionamentos', 'Família'],
    bio: 'Ajudo casais e famílias a melhorarem a comunicação e a reconstruírem laços. Acredito que relacionamentos saudáveis são a base da felicidade.',
    education: 'Mestrado em Terapia Familiar - Portugal',
    languages: ['Português', 'Inglês'],
    pricePerSession: 20000,
    currency: 'Kz',
    rating: 4.8,
    reviewCount: 89,
    isVerified: true,
    isAvailableToday: false,
    availability: [],
    whatsappNumber: '+244900000002',
    yearsOfExperience: 12,
    location: 'Luanda',
  },
  {
    id: '3',
    name: 'Dra. Maria José',
    photo: '/images/professional-3.jpg',
    specialty: 'Psicologia Infantil',
    specialties: ['Família', 'Ansiedade'],
    bio: 'Especialista em ajudar crianças e adolescentes a lidarem com emoções difíceis. Trabalho em parceria com as famílias.',
    education: 'Licenciatura em Psicologia - UAN',
    languages: ['Português'],
    pricePerSession: 12000,
    currency: 'Kz',
    rating: 4.9,
    reviewCount: 156,
    isVerified: true,
    isAvailableToday: true,
    availability: [],
    whatsappNumber: '+244900000003',
    yearsOfExperience: 6,
    location: 'Benguela',
  },
  {
    id: '4',
    name: 'Dr. Pedro Fonseca',
    photo: '/images/professional-4.jpg',
    specialty: 'Psicoterapia',
    specialties: ['Trauma', 'Depressão', 'Stress'],
    bio: 'Acompanho pessoas em processos de cura e transformação. Ofereço um espaço seguro para explorar desafios emocionais.',
    education: 'Mestrado em Psicoterapia - Brasil',
    languages: ['Português'],
    pricePerSession: 18000,
    currency: 'Kz',
    rating: 4.7,
    reviewCount: 64,
    isVerified: true,
    isAvailableToday: true,
    availability: [],
    whatsappNumber: '+244900000004',
    yearsOfExperience: 10,
    location: 'Luanda',
  },
  {
    id: '5',
    name: 'Dra. Luísa Costa',
    photo: '/images/professional-5.jpg',
    specialty: 'Psicologia Organizacional',
    specialties: ['Stress', 'Ansiedade'],
    bio: 'Ajudo profissionais a gerirem stress no trabalho e a encontrarem equilíbrio entre vida pessoal e profissional.',
    education: 'Licenciatura em Psicologia - UAN',
    languages: ['Português', 'Inglês'],
    pricePerSession: 14000,
    currency: 'Kz',
    rating: 4.8,
    reviewCount: 92,
    isVerified: true,
    isAvailableToday: false,
    availability: [],
    whatsappNumber: '+244900000005',
    yearsOfExperience: 7,
    location: 'Huíla — Lubango',
  },
  {
    id: '6',
    name: 'Dr. João Paulo',
    photo: '/images/professional-6.jpg',
    specialty: 'Terapia Cognitivo-Comportamental',
    specialties: ['Ansiedade', 'Depressão', 'Trauma'],
    bio: 'Utilizo técnicas práticas e eficazes para ajudar a mudar padrões de pensamento negativos e comportamentos.',
    education: 'Especialização em TCC - Portugal',
    languages: ['Português'],
    pricePerSession: 16000,
    currency: 'Kz',
    rating: 4.9,
    reviewCount: 113,
    isVerified: true,
    isAvailableToday: true,
    availability: [],
    whatsappNumber: '+244900000006',
    yearsOfExperience: 9,
    location: 'Luanda',
  },
];

export const testimonials: Testimonial[] = [
  {
    id: '1',
    name: 'Mariana T.',
    text: 'A Kuiva mudou a minha vida. Encontrei uma psicóloga incrível que me ajudou a superar a ansiedade. O processo foi simples e discreto.',
    rating: 5,
    professionalName: 'Dra. Ana Silva',
  },
  {
    id: '2',
    name: 'Ricardo L.',
    text: 'Poder falar no WhatsApp fez toda a diferença. Não precisava de instalar nada novo, foi muito prático.',
    rating: 5,
    professionalName: 'Dr. Carlos Mendes',
  },
  {
    id: '3',
    name: 'Fernanda K.',
    text: 'O preço é justo e posso pagar de várias formas. Finalmente tenho acesso a apoio psicológico de qualidade.',
    rating: 5,
    professionalName: 'Dra. Maria José',
  },
  {
    id: '4',
    name: 'Paulo M.',
    text: 'Senti-me acolhido desde o primeiro momento. A Dra. Ana é muito atenciosa e profissional.',
    rating: 5,
    professionalName: 'Dra. Ana Silva',
  },
];

export const paymentMethods: PaymentMethod[] = [
  {
    id: 'multicaixa',
    name: 'Referência Multicaixa',
    description: 'Gera uma referência para pagar em qualquer ATM Multicaixa',
    icon: 'CreditCard',
  },
  {
    id: 'transfer',
    name: 'Transferência Bancária',
    description: 'Transfira diretamente para a conta do profissional',
    icon: 'Banknote',
  },
  {
    id: 'cash',
    name: 'Pagar Presencialmente',
    description: 'Pague diretamente ao profissional na hora da consulta',
    icon: 'Wallet',
  },
];

export const howItWorksSteps = [
  {
    id: '1',
    title: 'Escolhe um profissional',
    description: 'Explora perfis de psicólogos angolanos qualificados e encontra quem melhor te compreende.',
    icon: 'Search',
  },
  {
    id: '2',
    title: 'Marca a tua sessão',
    description: 'Escolhe o dia e hora que te convém. Podes pagar de várias formas simples.',
    icon: 'Calendar',
  },
  {
    id: '3',
    title: 'Conversa com segurança',
    description: 'Fala pelo WhatsApp ou videochamada num espaço confidencial e acolhedor.',
    icon: 'MessageCircle',
  },
];

export const features = [
  {
    id: '1',
    title: 'Profissionais Angolanos',
    description: 'Todos os psicólogos são qualificados e falam português de Angola.',
    icon: 'MapPin',
  },
  {
    id: '2',
    title: 'Preços em Kwanza',
    description: 'Valores claros e acessíveis, sem surpresas. Paga da forma que te convém.',
    icon: 'Banknote',
  },
  {
    id: '3',
    title: 'Atendimento via WhatsApp',
    description: 'Fala diretamente pelo WhatsApp, a app que já usas todos os dias.',
    icon: 'Phone',
  },
  {
    id: '4',
    title: '100% Confidencial',
    description: 'A tua privacidade é a nossa prioridade. Tudo é seguro e discreto.',
    icon: 'Lock',
  },
];
